import axios from "axios";
import React, { useEffect, useState } from "react";
import "./logimage.scss";
import qr from "qrcode";
import QRCode from "react-qr-code";
import defaultImage from "../../../../assets/image/Default-User.png";

function Logimage() {
  const id = JSON.parse(window.localStorage.getItem("logId"));
  const [data, setData] = useState(false);
  const [image, setImage] = useState("");
  const [postSucces, setPostSuccess] = useState(false);
  const [src, setSrc] = useState("");

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    setData(result.data.data[0]);
    qrCode(result.data.data[0].qr);
    setSrc(result.data.data[0].qr);
  };

  const addPhoto = async () => {
    const postImage = new FormData();
    postImage.append("image", image);
    const resultPost = await axios.put(
      `https://mobile.amospa.com/users/${id}`,
      postImage
    );
    setPostSuccess(resultPost);
  };

  // Handle QR
  const qrCode = async (data) => {
    const generateQr = await qr.toDataURL(`${data}`);
    setSrc(generateQr);
  };
  useEffect(() => {
    getData();
  }, [postSucces]);
  return (
    <div className="logImage">
      <div className="wrapperImage">
        <div>
          <img
            src={data ? data.image : defaultImage}
            alt=""
            className="img-log-member"
          />
          <div id="wrapper-qr">
            <img src={src} alt="" id="qr-code" />
          </div>
        </div>
      </div>
      <div className="wrapperInput mt-3">
        <input type="file" onChange={(e) => setImage(e.target.files[0])} />
        <button className="bg-success" onClick={() => addPhoto()}>
          Upload Image
        </button>
      </div>
    </div>
  );
}

export default Logimage;
